import React, { useState, useEffect } from "react";
import {
  Table,
  Splitter,
  Pagination,
  Spin,
  Tag,
  Switch,
  Form,
  Badge,
  Tooltip,
} from "antd";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import {
  CaAdminLearningMenu,
  // LearningRecordsNav,
} from "../../../components/AdminComponents/MenuItems";
// import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import {
  capitalizeWords,
  ModuleColor,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import { useSelector } from "react-redux";
import axiosInstance from "../../../api/Axios";
import EditableImage from "../../../components/icons/EditIcon";
import { useNavigate } from "react-router-dom";
import ListingColumnModal from "./ListingColumnModal";
import {
  ControlTwoTone,
  CloseOutlined,
  CheckOutlined,
  FileTextTwoTone,
} from "@ant-design/icons";
import { GetFormattedDateTime } from "../../../components/utils/DateTimeUtils";
import FilePreviewModal from "../../../components/FilePreviewModal";
import useCommonListing from "../../../components/AdminComponents/customHooks/useCommonListing";
import RecordsFiltersSplitter from "./RecordsFiltersSplitter";
import { accessImpersontate } from "../../../config";
import moment from "moment";

const LearningRecords = () => {
  const [showFilter, setShowFilter] = useState(true);
  const history = useNavigate();
  const handleFilterChange = () => {
    setShowFilter((prev) => !prev);
  };

  const [categorySearch, setCategorySearch] = useState("");

  const [filterOptions, setFilterOptions] = useState({
    classifications: [],
    categories: [],
    languages: [],
    modes: [],
    states: [],
  });
  const [checkedKeys, setCheckedKeys] = useState([]);
  const { classifications, categories, languages, modes, states } =
    filterOptions;
  const updateFilterOption = (key, value) => {
    setFilterOptions((prev) => ({ ...prev, [key]: value }));
  };

  const userInfo = useSelector((state) => state.user);
  const ImpersonateAccess = !accessImpersontate(
    userInfo?.data?.impersonate_acc
  );
  useEffect(() => {
    const LoadFilters = async () => {
      try {
        const res = await axiosInstance.get(
          `learn/lrsfilter/?organization=${userInfo?.data?.organization?.id}`
        );
        updateFilterOption("classifications", res?.data?.classifications);
        updateFilterOption("categories", res?.data?.categories);
        updateFilterOption("languages", res?.data?.languages);
        updateFilterOption("modes", res?.data?.modes);
        updateFilterOption("states", res?.data?.state);
      } catch (err) {
        console.log(err);
      }
    };
    LoadFilters();
  }, [userInfo?.data?.organization?.id]);

  const {
    data,
    itemsLength,
    loading,
    filterData,
    setFilterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    handleSwitchChange,
    handleClearAll,
    setFilterUrl,
  } = useCommonListing({
    userInfo,
    passSize: 15,
    passPage: 1,
    passURL: `/learningrecordlist/?organization=${userInfo?.data?.organization?.id}`,
    persist: true,
    listId: "recordList",
  });

  const {
    pageSize,
    currentPage,
    active,
    filter_url,
    sort_column,
    sort_order,
    search,
  } = filterData;
  const handleRowClick = (record) => {
    history(`/ca-admin/trainery-learn/records/edit/${record}`);
  };
  // eslint-disable-next-line no-unused-vars
  const renderStatus = (text, record) => {
    if (record?.state === "Completed") {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Tooltip title={"Completed"}>
            <div
              style={{
                width: "1.8rem",
                height: "1.8rem",
                borderRadius: "50%",
                backgroundColor: "#52c41a",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CheckOutlined
                style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
              />
            </div>
          </Tooltip>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  const [previewVisible, setPreviewVisible] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [selectedFile, setSelectedFile] = useState("");
  const [selectedRecord, setSelectedRecord] = useState();
  const handlePreview = (fileUrl, record) => {
    setSelectedFile(fileUrl);
    setPreviewVisible(true);
    setSelectedRecord(record);
  };
  const getDefaultSortOrder = (column) => {
    if (sort_column === column) {
      return sort_order === "asc" ? "ascend" : "descend";
    }
    return null;
  };
  const handleSortChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setFilterData({
        ...filterData,
        sort_column: sorter.field,
        sort_order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setFilterData({
        ...filterData,
        sort_column: "",
        sort_order: "",
      });
    }
  };

  // eslint-disable-next-line no-unused-vars
  const [allColumns, setAllColumns] = useState([
    {
      title: "Learning Record",
      dataIndex: "learningrecord_id",
      key: "learningrecord_id",
      fixed: "left",
      width: 150,
    },
    {
      title: "Learner",
      dataIndex: "user_name",
      key: "user_name",
      fixed: "left",
      width: 180,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("name"),
    },
    {
      title: "Assignment ID",
      dataIndex: "assignment_id",
      key: "assignment_id",
      width: 120,
    },
    {
      title: "Course Title",
      dataIndex: "course_name",
      key: "course_name",
      width: 220,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("course_name"),
    },

    {
      title: "User ID",
      dataIndex: "user_id",
      key: "user_id",
      width: 120,
    },
    {
      title: "Certificate",
      dataIndex: "certificate",
      key: "certificate",
      width: 120,
      align: "center",
      render: (certificate, record) => {
        return record?.certificate ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation(); // prevent triggering row click
              handlePreview(record.certificate, record);
            }}
          >
            <FileTextTwoTone style={{ fontSize: "1.5rem", marginRight: 8 }} />
          </div>
        ) : (
          ""
        );
      },
    },

    {
      title: "Course Type",
      dataIndex: "mode",
      key: "mode",
      width: 120,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("mode"),
    },
    {
      title: "Course CPE",
      dataIndex: "cpe",
      key: "cpe",
      width: 120,
      align: "center",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("cpe"),
    },
    {
      title: "Source Module",
      dataIndex: "source_app",
      key: "source_app",
      width: 120,
      align: "center",
      render: (applications) => (
        <span>
          <Tag
            color={ModuleColor(applications)}
            title={applications}
            style={{ margin: "3px" }}
          >
            <span style={{ color: "black", fontWeight: "500" }}>
              {applications}
            </span>
          </Tag>
        </span>
      ),
    },
    {
      title: capitalizeWords("Source"),
      dataIndex: "source",
      key: "source",
      width: 120, // set width to 150px
      align: "center",
      render: (origin) =>
        origin ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Center horizontally
              alignItems: "center", // Center vertically
            }}
          >
            <Tooltip
              title={
                origin === "M"
                  ? "Manually Created record"
                  : "System Generated record"
              }
            >
              <Tag
                color="purple"
                style={{
                  fontSize: "1.15rem",
                  width: "2.5rem",
                  height: "2.5rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%", // Make it a circle
                  fontWeight: "600",
                  padding: 0, // Remove padding for a perfect circle
                }}
              >
                {origin}
              </Tag>
            </Tooltip>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Center horizontally
              alignItems: "center", // Center vertically
            }}
          >
            <Tooltip title="Source Unknown">
              <Tag
                color="purple"
                style={{
                  fontSize: "1.15rem",
                  width: "2.5rem",
                  height: "2.5rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%", // Make it a circle
                  fontWeight: "600",
                  padding: 0, // Remove padding for a perfect circle
                }}
              >
                UN
              </Tag>
            </Tooltip>
          </div>
        ),
    },
    {
      title: "Attachments",
      dataIndex: "attachment_url",
      key: "attachment_url",
      align: "center",
      width: 150,
      render: (attachment_url, record) => {
        if (Array.isArray(attachment_url) && attachment_url.length > 0) {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px", // space between icons
                height: "100%",
              }}
            >
              {attachment_url?.map((item, index) => (
                <FileTextTwoTone
                  key={index}
                  style={{ fontSize: "1.5rem", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePreview(item?.url, record);
                  }}
                />
              ))}
            </div>
          );
        }
        return "--";
      },
    },
    {
      title: "Attendance Proof",
      dataIndex: "attendance_proof",
      key: "attendance_proof",
      width: 150,
      align: "center",
      render: (attendance_proof, record) => {
        return record?.attendance_proof ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation(); // prevent triggering row click
              handlePreview(record.attendance_proof, record);
            }}
          >
            <FileTextTwoTone style={{ fontSize: "1.5rem", marginRight: 8 }} />
          </div>
        ) : (
          ""
        );
      },
    },
    { title: "Language", dataIndex: "language", key: "language", width: 120 },

    {
      title: "Attended On",
      dataIndex: "attended_on",
      key: "attended_on",
      width: 120,
      render: GetFormattedDateTime,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("attended_on"),
    },
    {
      title: "Enrolled On",
      dataIndex: "enrolled_on",
      key: "enrolled_on",
      width: 120,
      render: GetFormattedDateTime,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("enrolled_on"),
    },
    {
      title: "Completed On",
      dataIndex: "completed_on",
      key: "completed_on",
      width: 120,
      render: GetFormattedDateTime,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("completed_on"),
    },
    {
      title: capitalizeWords("Status"),
      dataIndex: "state",
      key: "state",
      render: renderStatus,
      width: 100,
      align: "center",
    },
    {
      title: capitalizeWords("actions"),
      dataIndex: "actions",
      key: "actions",
      align: "center",
      width: 120,
      fixed: "right",
      render: (text, record) =>
        record?.is_editable ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <EditableImage
              handleRowClick={handleRowClick}
              recordId={record.id}
            />
          </div>
        ) : (
          ""
        ),
    },
  ]);
  const [visibleColumns, setVisibleColumns] = useState(
    allColumns.map((col) => col.key)
  );
  const [hasChanges, setHasChanges] = useState(false);
  useEffect(() => {
    const defaultKeys = allColumns.map((col) => col.key);

    const isSame =
      visibleColumns.length === defaultKeys.length &&
      visibleColumns.every((key, index) => key === defaultKeys[index]);

    setHasChanges(!isSame);
  }, [visibleColumns, allColumns]);
  const filteredColumns = visibleColumns
    .map((key) => allColumns.find((col) => col.key === key))
    .filter(Boolean);
  const resetColumns = () => {
    setVisibleColumns(allColumns.map((col) => col.key));
  };

  const [form] = Form.useForm();

  const handleDecodedFormValues = (allValues) => {
    const {
      source_app = [],
      language = [],
      mode = [],
      categories = [],
      state = [],
      date_type,
      dateRange,
    } = allValues;
    const categoryKeys = Array.isArray(categories) ? categories : [];

    const grouped = {
      category: [],
      second_category: [],
      third_category: [],
    };

    categoryKeys.forEach((item) => {
      const [prefix, id] = item.split("-");
      const numericId = parseInt(id);
      if (!isNaN(numericId)) {
        if (prefix === "cat") grouped.category.push(numericId);
        else if (prefix === "sub") grouped.second_category.push(numericId);
        else if (prefix === "third") grouped.third_category.push(numericId);
      }
    });

    const params = new URLSearchParams();

    if (source_app.length) {
      params.append("source_app", source_app.join(","));
    }
    if (language.length) {
      params.append("language", language.join(","));
    }
    if (mode.length) {
      params.append("mode", mode.join(","));
    }
    if (state.length) {
      params.append("state", state.join(","));
    }
    Object.entries(grouped).forEach(([key, values]) => {
      if (values.length > 0) {
        params.append(key, values.join(","));
      }
    });

    // Handle date range filter
    if (date_type && dateRange && Array.isArray(dateRange) && dateRange.length === 2) {
      const startDate = moment(dateRange[0]).format("YYYY-MM-DD");
      const endDate = moment(dateRange[1]).format("YYYY-MM-DD");
      params.append("date_type", date_type);
      params.append("date_range", `${startDate},${endDate}`);
    }

    const generatedFilterUrl = params.toString();
    setFilterUrl(generatedFilterUrl);

    console.log("Updated filter_url:", generatedFilterUrl);
  };

  const handleCheck = (checkedKeysValue, info) => {
    const finalKeys = Array.isArray(checkedKeysValue)
      ? checkedKeysValue
      : checkedKeysValue.checked;

    setCheckedKeys(finalKeys);

    form.setFieldsValue({
      categories: finalKeys,
    });

    const allValues = form.getFieldsValue();
    handleDecodedFormValues(allValues);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setVisibleColumns((prev) => {
      if (checked) {
        return [...prev, value]; // Add the column to the visible list if checked
      } else {
        return prev.filter((column) => column !== value); // Remove the column from the visible list if unchecked
      }
    });
  };
  const handleColumnSubmit = (newColumns) => {
    // Always ensure "actions" is last
    const reordered = newColumns.filter((col) => col !== "actions");
    if (newColumns.includes("actions")) {
      reordered.push("actions");
    }
    console.log(newColumns, "newColumns");
    setVisibleColumns(reordered); // Update visible columns with correct order
    console.log(visibleColumns);
  };
  const columnOptions = allColumns.map((col) => ({
    label: col.title,
    value: col.key,
  }));
  return (
    <CaSideNav props={CaAdminLearningMenu}>
      {/* <SecondaryNav menuItems={LearningRecordsNav} /> */}
      <CommonTopDetails
        title={active ? "Learning Records Summary" : "Inactive Records"}
        titleSuffix={`${itemsLength || 0} record(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        searchValue={search}
        showAddButton={ImpersonateAccess}
        filterAction={true}
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: "/ca-admin/trainery-learn/records/add",
        }}
        filterUrl={filter_url}
        filterButtonProps={{
          modalType: "PopUP",
          modalProps: handleFilterChange,
        }}
        resetButtonProps={{
          modalProps: handleClearAll,
        }}
        customContent={
          <>
            <Switch
              style={{
                backgroundColor: active ? "#50C878" : "#FF0000",
                minWidth: "90px",
              }}
              checked={active}
              disabled={loading}
              onChange={handleSwitchChange}
              checkedChildren="ACTIVE"
              unCheckedChildren="INACTIVE"
            />
            {false && (
              <Badge dot={hasChanges}>
                <ControlTwoTone
                  onClick={() => setIsModalOpen(true)}
                  style={{ fontSize: "29.5px" }}
                />
              </Badge>
            )}
          </>
        }
      />
      <Splitter
        style={{
          height: `${remainingViewportHeight(17)}px`,
          transition: "all 1s ease",
        }}
      >
        {showFilter && (
          <Splitter.Panel defaultSize="17.5%" min="15%" max="40%">
            <RecordsFiltersSplitter
              form={form}
              handleDecodedFormValues={handleDecodedFormValues}
              setShowFilter={setShowFilter}
              handleClearAll={handleClearAll}
              classifications={classifications}
              languages={languages}
              categories={categories}
              modes={modes}
              states={states}
              categorySearch={categorySearch}
              setCategorySearch={setCategorySearch}
              checkedKeys={checkedKeys}
              handleCheck={handleCheck}
              filter_url={filter_url}
              origin="CLIENT_ADMIN"
              showState={true}
            />
          </Splitter.Panel>
        )}
        <Splitter.Panel
          className="table-wrapper"
          style={{ overflowX: "auto", overflowY: "auto" }}
        >
          <Spin spinning={loading}>
            <div
              className="table-wrapper"
              style={{ overflowX: "auto", overflowY: "auto" }}
            >
              <Table
                columns={filteredColumns}
                dataSource={data}
                size="small"
                bordered
                rowKey="id"
                className="table-container"
                scroll={{
                  x: 1000,
                  y: `${remainingViewportHeight(29)}px`,
                }}
                onRow={(record) => ({
                  onClick: (event) => {
                    if (
                      event.target.closest(
                        ".ant-table-cell[data-index='actions']"
                      )
                    ) {
                      return;
                    }

                    handleRowClick(record.id);
                  },
                })}
                style={{ marginInline: "1rem" }}
                pagination={false}
                onChange={handleSortChange}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "1rem",
                }}
              >
                <Pagination
                  size="small"
                  showSizeChanger
                  onShowSizeChange={onShowSizeChange}
                  onChange={onPageChange}
                  pageSizeOptions={["10", "15", "30", "50", "100"]}
                  showQuickJumper
                  current={currentPage}
                  defaultPageSize={pageSize}
                  total={itemsLength}
                />
              </div>
            </div>

            <ListingColumnModal
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              columnOptions={columnOptions}
              visibleColumns={visibleColumns}
              handleCheckboxChange={handleCheckboxChange}
              onSubmit={handleColumnSubmit}
              resetColumns={resetColumns}
            />
          </Spin>
        </Splitter.Panel>
      </Splitter>
      <FilePreviewModal
        open={previewVisible}
        onClose={() => setPreviewVisible(false)}
        fileUrl={selectedFile}
        selectedRecord={selectedRecord}
      />
    </CaSideNav>
  );
};

export default LearningRecords;
